export default {
  lookups: {},
  groups: [],
  timeZones: [],
  countries: [],
  stateProvinces: [],
  languages: [],
  brand: [],
  newInsurance: null,
  search: '',
  selectedInsurance: null,
  insuranceLookup: [],
  sourceInsurance: [],
  insurance: [],
  loading: false
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/state.js